<template>
  <div id="app">
    <router-view></router-view>
    <SliderView style="display: none;" />
    <!-- /.login-box -->
    <loading
      :active.sync="$store.state.isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import SliderView from './components/slider'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'app',
  components: {
    SliderView,
    Loading
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue